import PropTypes from 'prop-types';

/**
 * Petit avion qui décolle (au-dessus d'une piste) : action « appliquer ce
 * modèle à tous les vols actifs ».
 */
const PlaneTakeOffIcon = ({ width = 20, height = 20, color = '#016593', fill = '#016593' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="rotate(38 12 10.5)">
      <path
        d="M12 2.4c.62 0 1.12.72 1.12 1.6v4.55l5.63 3.32v1.66l-5.63-1.63v3.36l1.63 1.22v1.44L12 17.4l-2.75.52v-1.44l1.63-1.22v-3.36L5.25 13.53v-1.66l5.63-3.32V4c0-.88.5-1.6 1.12-1.6z"
        fill={fill}
      />
    </g>
    <path d="M2.6 21h9.6" stroke={color} strokeWidth="1.8" strokeLinecap="round" />
    <path
      d="M15.4 20.2h5.4m0 0l-1.8-1.8m1.8 1.8l-1.8 1.8"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

PlaneTakeOffIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  fill: PropTypes.string,
};

PlaneTakeOffIcon.defaultProps = {
  width: 20,
  height: 20,
  color: '#016593',
  fill: '#016593',
};

export default PlaneTakeOffIcon;
